export const jainMenu = [
  // ===== STARTERS =====
  {
    id: 301,
    title: 'Malai Broccoli',
    category: 'starters',
    description: 'Malai Broccoli in green herb marinade, grilled for a smoky finish.',
    rating: 4.8,
    image: '/Images/JainMenu-STARTERS/1.Malai Brocolli.png',
    portionSize: '2PCS',
    pricePerPortion: '₹80',
    basePrice: 80,
    serves: 5,
    quantity: '10PCS',
    unit: 'PCS'
  },
  {
    id: 302,
    title: 'Stuffed Aloo Tikka',
    category: 'starters',
    description: 'Stuffed Aloo Tikka, tandoor-roasted with spices.',
    rating: 4.7,
    image: '/Images/JainMenu-STARTERS/2.StuffedAlooTikka.png',
    portionSize: '2PCS',
    pricePerPortion: '₹70',
    basePrice: 70,
    serves: 5,
    quantity: '10PCS',
    unit: 'PCS'
  },
  {
    id: 303,
    title: 'Chilli Basil Tofu',
    category: 'starters',
    description: 'Chilli Basil Tofu, mild and rich.',
    rating: 4.8,
    image: '/Images/JainMenu-STARTERS/3.Chilli Basil Tofu.png',
    portionSize: '2PCS',
    pricePerPortion: '₹80',
    basePrice: 80,
    serves: 5,
    quantity: '10PCS',
    unit: 'PCS'
  },
  {
    id: 304,
    title: 'Chilli Paneer Tikka',
    category: 'starters',
    description: 'Chilli Paneer, char-grilled in the tandoor.',
    rating: 4.6,
    image: '/Images/JainMenu-STARTERS/4.Chilli Paneer.png',
    portionSize: '2PCS',
    pricePerPortion: '₹50',
    basePrice: 50,
    serves: 5,
    quantity: '10PCS',
    unit: 'PCS'
  },
  {
    id: 305,
    title: 'Chilli Mushroom',
    category: 'starters',
    description: 'Crispy mushroom tossed in sweet-spicy honey chilli glaze.',
    rating: 4.6,
    image: '/Images/JainMenu-STARTERS/5.Chilli Mushroom.png',
    portionSize: '100GM',
    pricePerPortion: '₹50',
    basePrice: 50,
    serves: 5,
    quantity: '500GM',
    unit: 'GM'
  },
  {
    id: 306,
    title: 'Dahi Kebab',
    category: 'starters',
    description: 'Dahi Kebab, creamy dressing.',
    rating: 4.6,
    image: '/Images/JainMenu-STARTERS/6.Dahi Kebab.jpg',
    portionSize: '2PCS',
    pricePerPortion: '₹50',
    basePrice: 50,
    serves: 5,
    quantity: '10PCS',
    unit: 'PCS'
  },
  {
    id: 307,
    title: 'Cottage Cheese Satay',
    category: 'starters',
    description: 'Cottage Cheese Satay, mild and rich.',
    rating: 4.8,
    image: '/Images/JainMenu-STARTERS/7.Cottage Cheese Satay.jpg',
    portionSize: '2PCS',
    pricePerPortion: '₹80',
    basePrice: 80,
    serves: 5,
    quantity: '10PCS',
    unit: 'PCS'
  },
  // {
  //   id: 308,
  //   title: 'Kesariya Paneer Tikka',
  //   category: 'starters',
  //   description: 'Saffron-infused marinade on paneer, subtle and aromatic.',
  //   rating: 4.8,
  //   image: '/Images/JainMenuStarters/8KESARIYA PANEER TIKKA.jpg',
  //   portionSize: '2PCS',
  //   pricePerPortion: '₹100',
  //   basePrice: 100,
  //   serves: 5,
  //   quantity: '10PCS',
  //   unit: 'PCS'
  // },
  // {
  //   id: 309,
  //   title: 'Malai Paneer Tikka',
  //   category: 'starters',
  //   description: 'Rich malai-spiced paneer, soft and mildly spiced.',
  //   rating: 4.9,
  //   image: '/Images/JainMenuStarters/9MALAI PANEER TIKKA.jpg',
  //   portionSize: '2PCS',
  //   pricePerPortion: '₹110',
  //   basePrice: 110,
  //   serves: 5,
  //   quantity: '10PCS',
  //   unit: 'PCS'
  // },
  // {
  //   id: 310,
  //   title: 'Chilli Paneer Tikka',
  //   category: 'starters',
  //   description: 'Paneer tikka with a bold chilli kick.',
  //   rating: 4.7,
  //   image: '/Images/JainMenuStarters/10CHILLI PANEER TIKKA.jpg',
  //   portionSize: '2PCS',
  //   pricePerPortion: '₹80',
  //   basePrice: 80,
  //   serves: 5,
  //   quantity: '10PCS',
  //   unit: 'PCS'
  // },
  // {
  //   id: 311,
  //   title: 'Malai Broccoli',
  //   category: 'starters',
  //   description: 'Creamy malai broccoli florets, tandoor-finished.',
  //   rating: 4.6,
  //   image: '/Images/JAIN-STARTERS-MENU/Malai Broccoli.jpg',
  //   portionSize: '2PCS',
  //   pricePerPortion: '₹120',
  //   basePrice: 120,
  //   serves: 5,
  //   quantity: '10PCS',
  //   unit: 'portion'
  // },
  // {
  //   id: 312,
  //   title: 'Stuffed Aloo Tikka',
  //   category: 'starters',
  //   description: 'Aloo tikka stuffed with spiced cottage cheese.',
  //   rating: 4.6,
  //   image: '/Images/JAIN-STARTERS-MENU/Stuffed Aloo Tikka.jpg',
  //   portionSize: '2PCS',
  //   pricePerPortion: '₹70',
  //   basePrice: 70,
  //   serves: 5,
  //   quantity: '10PCS',
  //   unit: 'portion'
  // },
  // {
  //   id: 313,
  //   title: 'Chilli Basil Tofu',
  //   category: 'starters',
  //   description: 'Tofu tossed with basil and chilli, Indo-Asian style.',
  //   rating: 4.6,
  //   image: '/Images/JAIN-STARTERS-MENU/Chilli Basil Tofu.jpg',
  //   portionSize: '2PCS',
  //   pricePerPortion: '₹70',
  //   basePrice: 70,
  //   serves: 5,
  //   quantity: '10PCS',
  //   unit: 'portion'
  // },
  // {
  //   id: 314,
  //   title: 'Chilli Mushroom',
  //   category: 'starters',
  //   description: 'Crispy mushroom in spicy chilli sauce.',
  //   rating: 4.6,
  //   image: '/Images/JAIN-STARTERS-MENU/Chilli Mushroom.jpg',
  //   portionSize: '2PCS',
  //   pricePerPortion: '₹100',
  //   basePrice: 100,
  //   serves: 5,
  //   quantity: '10PCS',
  //   unit: 'portion'
  // },
  // {
  //   id: 315,
  //   title: 'Dahi Kabab',
  //   category: 'starters',
  //   description: 'Silky hung-curd kababs, shallow-fried to golden.',
  //   rating: 4.7,
  //   image: '/Images/JAIN-STARTERS-MENU/Dahi Kabab.jpg',
  //   portionSize: '2PCS',
  //   pricePerPortion: '₹80',
  //   basePrice: 80,
  //   serves: 5,
  //   quantity: '10PCS',
  //   unit: 'portion'
  // },
  // {
  //   id: 316,
  //   title: 'Cottage Cheese Satay',
  //   category: 'starters',
  //   description: 'Smoky satay-style paneer with peanut glaze.',
  //   rating: 4.7,
  //   image: '/Images/JAIN-STARTERS-MENU/Cottage Cheese Satay.jpg',
  //   portionSize: '2PCS',
  //   pricePerPortion: '₹70',
  //   basePrice: 70,
  //   serves: 5,
  //   quantity: '10PCS',
  //   unit: 'portion'
  // },

  {
    id: 308,
    title: 'Haryali Paneer Tikka',
    category: 'starters',
    description: 'Green herb marinated paneer tikka, grilled for smoky flavor.',
    rating: 4.8,
    image: '/Images/JainMenuStarters/8KESARIYA PANEER TIKKA.jpg',
    portionSize: '2PCS',
    pricePerPortion: '₹80',
    basePrice: 80,
    serves: 5,
    quantity: '10PCS',
    unit: 'PCS'
  },
  {
    id: 309,
    title: 'Soya Chaap Tikka',
    category: 'starters',
    description: 'Tandoor-grilled soya chaap marinated in spiced yogurt.',
    rating: 4.7,
    image: '/Images/JainNewImage/SOYA CHAAP TIKKA.jpg',
    portionSize: '2PCS',
    pricePerPortion: '₹70',
    basePrice: 70,
    serves: 5,
    quantity: '10PCS',
    unit: 'PCS'
  },
  {
    id: 310,
    title: 'Malai Soya Chaap',
    category: 'starters',
    description: 'Creamy malai marinated soya chaap, tandoor grilled.',
    rating: 4.8,
    image: '/Images/JainNewImage/MALAI SOYA CHAAP.jpg',
    portionSize: '2PCS',
    pricePerPortion: '₹80',
    basePrice: 80,
    serves: 5,
    quantity: '10PCS',
    unit: 'PCS'
  },
  {
    id: 311,
    title: 'Tandoori Aloo',
    category: 'starters',
    description: 'Baby potatoes marinated in tandoori spices and grilled.',
    rating: 4.6,
    image: '/Images/JainNewImage/TANDOORI  ALOO.jpg',
    portionSize: '2PCS',
    pricePerPortion: '₹50',
    basePrice: 50,
    serves: 5,
    quantity: '10PCS',
    unit: 'PCS'
  },
  {
    id: 312,
    title: 'Honey Chilli Potato',
    category: 'starters',
    description: 'Crispy potato fingers tossed in sweet-spicy honey chilli glaze.',
    rating: 4.7,
    image: '/Images/JainNewImage/HONEY CHILLI POTATO.jpg',
    portionSize: '100GM',
    pricePerPortion: '₹60',
    basePrice: 60,
    serves: 5,
    quantity: '500GM',
    unit: 'GM'
  },
  {
    id: 313,
    title: 'Cajun Potato',
    category: 'starters',
    description: 'Potato wedges seasoned with Cajun spices, oven roasted.',
    rating: 4.6,
    image: '/Images/JainNewImage/CAJUN POTATO.jpg',
    portionSize: '100GM',
    pricePerPortion: '₹60',
    basePrice: 60,
    serves: 5,
    quantity: '500GM',
    unit: 'GM'
  },
  {
    id: 314,
    title: 'Paneer Tikka',
    category: 'starters',
    description: 'Classic paneer tikka marinated in tandoori spices and grilled.',
    rating: 4.8,
    image: '/Images/JainMenu-STARTERS/4.Chilli Paneer.png',
    portionSize: '2PCS',
    pricePerPortion: '₹80',
    basePrice: 80,
    serves: 5,
    quantity: '10PCS',
    unit: 'PCS'
  },
  {
    id: 315,
    title: 'Kesariya Paneer Tikka',
    category: 'starters',
    description: 'Saffron-infused paneer tikka with aromatic spices.',
    rating: 4.8,
    image: '/Images/JainMenuStarters/8KESARIYA PANEER TIKKA.jpg',
    portionSize: '2PCS',
    pricePerPortion: '₹100',
    basePrice: 100,
    serves: 5,
    quantity: '10PCS',
    unit: 'PCS'
  },
  {
    id: 316,
    title: 'Malai Paneer Tikka',
    category: 'starters',
    description: 'Rich malai marinated paneer, soft and mildly spiced.',
    rating: 4.9,
    image: '/Images/JainMenuStarters/9MALAI PANEER TIKKA.jpg',
    portionSize: '2PCS',
    pricePerPortion: '₹110',
    basePrice: 110,
    serves: 5,
    quantity: '10PCS',
    unit: 'PCS'
  },
  {
    id: 317,
    title: 'Chilli Paneer Tikka',
    category: 'starters',
    description: 'Spicy paneer tikka with bold chilli flavors.',
    rating: 4.7,
    image: '/Images/JainNewImage/CHILLI PANEER TIKKA.jpg',
    portionSize: '2PCS',
    pricePerPortion: '₹80',
    basePrice: 80,
    serves: 5,
    quantity: '10PCS',
    unit: 'PCS'
  },

  // ===== MAIN COURSE =====
  {
    id: 318,
    title: 'Paneer Butter Masala',
    category: 'main_course',
    description: 'Rich tomato-butter gravy with soft paneer cubes.',
    rating: 4.9,
    image: '/Images/JainNewImage/PANEER BUTTER MASALA.jpg',
    portionSize: '100GM',
    pricePerPortion: '₹100',
    basePrice: 100,
    serves: 5,
    quantity: '500GM',
    unit: 'GM'
  },
  {
    id: 319,
    title: 'Paneer Tikka Masala',
    category: 'main_course',
    description: 'Charred paneer tikka simmered in rich masala gravy.',
    rating: 4.9,
    image: '/Images/JainNewImage/PANEER TIKKA.jpg',
    portionSize: '100GM',
    pricePerPortion: '₹100',
    basePrice: 100,
    serves: 5,
    quantity: '500GM',
    unit: 'GM'
  },
  {
    id: 320,
    title: 'Paneer Lababdar',
    category: 'main_course',
    description: 'Paneer in rich creamy tomato gravy with aromatic spices.',
    rating: 4.9,
    image: '/Images/JainMenuMainCourse/3PANEER LABABDAR.jpg',
    portionSize: '100GM',
    pricePerPortion: '₹100',
    basePrice: 100,
    serves: 5,
    quantity: '500GM',
    unit: 'GM'
  },
  {
    id: 321,
    title: 'Kadhai Paneer',
    category: 'main_course',
    description: 'Paneer with capsicum in hand-crushed kadhai masala.',
    rating: 4.9,
    image: '/Images/JainMenuMainCourse/4KADHAI PANEER.jpg',
    portionSize: '100GM',
    pricePerPortion: '₹100',
    basePrice: 100,
    serves: 5,
    quantity: '500GM',
    unit: 'GM'
  },
  {
    id: 322,
    title: 'Shahi Paneer',
    category: 'main_course',
    description: 'Royal paneer in cashew-cream gravy, mildly sweet.',
    rating: 4.9,
    image: '/Images/JainMenuMainCourse/5SHAHI PANEER.jpg',
    portionSize: '100GM',
    pricePerPortion: '₹100',
    basePrice: 100,
    serves: 5,
    quantity: '500GM',
    unit: 'GM'
  },
  {
    id: 323,
    title: 'Matar Paneer',
    category: 'main_course',
    description: 'Paneer with green peas in home-style tomato gravy.',
    rating: 4.9,
    image: '/Images/JainMenuMainCourse/6MATAR PANEER.jpg',
    portionSize: '100GM',
    pricePerPortion: '₹100',
    basePrice: 100,
    serves: 5,
    quantity: '500GM',
    unit: 'GM'
  },
  {
    id: 324,
    title: 'Palak Paneer',
    category: 'main_course',
    description: 'Spinach puree with paneer, tempered with mild spices.',
    rating: 4.9,
    image: '/Images/JainMenuMainCourse/7PALAK PANEER.jpg',
    portionSize: '100GM',
    pricePerPortion: '₹100',
    basePrice: 100,
    serves: 5,
    quantity: '500GM',
    unit: 'GM'
  },
  {
    id: 325,
    title: 'Tawa Veg',
    category: 'main_course',
    description: 'Mixed vegetables tossed on tawa with aromatic spices.',
    rating: 4.9,
    image: '/Images/JainMenuMainCourse/8TAWA VEG.jpg',
    portionSize: '100GM',
    pricePerPortion: '₹100',
    basePrice: 100,
    serves: 5,
    quantity: '500GM',
    unit: 'GM'
  },
  {
    id: 326,
    title: 'Mix Veg',
    category: 'main_course',
    description: 'Seasonal mixed vegetables in light masala gravy.',
    rating: 4.9,
    image: '/Images/JainMenuMainCourse/9MIX VEG.jpg',
    portionSize: '100GM',
    pricePerPortion: '₹100',
    basePrice: 100,
    serves: 5,
    quantity: '500GM',
    unit: 'GM'
  },
  {
    id: 327,
    title: 'Soya Chaap Masala',
    category: 'main_course',
    description: 'Soya chaap in robust onion-tomato masala gravy.',
    rating: 4.9,
    image: '/Images/JainMenuMAIN COURSE/1.Soya Chaap Masala.png',
    portionSize: '100GM',
    pricePerPortion: '₹100',
    basePrice: 100,
    serves: 5,
    quantity: '500GM',
    unit: 'GM'
  },
  {
    id: 328,
    title: 'Dal Makhani',
    category: 'main_course',
    description: 'Slow-cooked black lentils finished with cream.',
    rating: 4.8,
    image: '/Images/JainMenuMAIN COURSE/2.Dal Makhani.png',
    portionSize: '100GM',
    pricePerPortion: '₹100',
    basePrice: 100,
    serves: 5,
    quantity: '500GM',
    unit: 'GM'
  },
  {
    id: 340,
    title: 'Malai Kofta',
    category: 'main_course',
    description: 'Creamy gravy with melt-in-mouth paneer koftas.',
    rating: 4.8,
    image: '/Images/JainNewImage/MALAI KOFTA.jpg',
    portionSize: '100GM',
    pricePerPortion: '₹120',
    basePrice: 120,
    serves: 5,
    quantity: '500',
    unit: 'portion'
  },
  {
    id: 341,
    title: 'Aloo Gobhi Adraki',
    category: 'main_course',
    description: 'Cauliflower and potatoes with ginger-forward flavors.',
    rating: 4.8,
    image: '/Images/JainNewImage/Aloo Gobhi Adraki.jpg',
    portionSize: '100GM',
    pricePerPortion: '₹120',
    basePrice: 120,
    serves: 5,
    quantity: '500',
    unit: 'portion'
  },
  {
    id: 342,
    title: 'Kadhai Veg',
    category: 'main_course',
    description: 'Spicy kadhai masala with mixed seasonal vegetables.',
    rating: 4.8,
    image: '/Images/JainNewImage/KADHAI VEG.jpg',
    portionSize: '100GM',
    pricePerPortion: '₹120',
    basePrice: 120,
    serves: 5,
    quantity: '500',
    unit: 'portion'
  },
  {
    id: 329,
    title: 'Dal Tadka',
    category: 'main_course',
    description: 'Yellow lentils tempered with ghee, cumin and spices.',
    rating: 4.9,
    image: '/Images/JainMenuMAIN COURSE/3.Dal Tadka.png',
    portionSize: '100GM',
    pricePerPortion: '₹100',
    basePrice: 100,
    serves: 5,
    quantity: '500GM',
    unit: 'GM'
  },
  {
    id: 330,
    title: 'Dum Aloo Kashmiri',
    category: 'main_course',
    description: 'Baby potatoes in rich Kashmiri-style yogurt gravy.',
    rating: 4.8,
    image: '/Images/JainMenuMAIN COURSE/4.Dum Aloo Kashmiri.png',
    portionSize: '100GM',
    pricePerPortion: '₹100',
    basePrice: 100,
    serves: 5,
    quantity: '500GM',
    unit: 'GM'
  },
  {
    id: 331,
    title: 'Veg Thai Curry',
    category: 'main_course',
    description: 'Coconut-based Thai curry with mixed vegetables.',
    rating: 4.8,
    image: '/Images/JainMenuMAIN COURSE/5.Veg Thai Curry.png',
    portionSize: '100GM',
    pricePerPortion: '₹110',
    basePrice: 110,
    serves: 5,
    quantity: '500',
    unit: 'PCS'
  },
  {
    id: 332,
    title: 'Amritsari Chole',
    category: 'main_course',
    description: 'Punjabi-style dark chole with whole spices.',
    rating: 4.7,
    image: '/Images/JainMenuMAIN COURSE/6.Amritsari Chole.png',
    portionSize: '100GM',
    pricePerPortion: '₹100',
    basePrice: 100,
    serves: 5,
    quantity: '500GM',
    unit: 'GM'
  },
  {
    id: 333,
    title: 'Hakka Noodles',
    category: 'main_course',
    description: 'Wok-tossed noodles with vegetables, Indo-Chinese style.',
    rating: 4.8,
    image: '/Images/JainMenuMAIN COURSE/7.Hakki Noodles.png',
    portionSize: '100GM',
    pricePerPortion: '₹120',
    basePrice: 120,
    serves: 5,
    quantity: '500',
    unit: 'PCS'
  },
  {
    id: 334,
    title: 'Pasta (Red/White/Pink)',
    category: 'main_course',
    description: 'Pasta with choice of arrabbiata, alfredo or mix sauce.',
    rating: 4.6,
    image: '/Images/JainMenuMAIN COURSE/8.PASTA(RED WHITE PINK).png',
    portionSize: '75GM',
    pricePerPortion: '₹90',
    basePrice: 90,
    serves: 5,
    quantity: '375GM',
    unit: 'GM'
  },
  {
    id: 335,
    title: 'Pav Bhaji',
    category: 'main_course',
    description: 'Buttery bhaji with soft pav, Jain-friendly preparation.',
    rating: 4.6,
    image: '/Images/JainMenuMAIN COURSE/9.Pav Bhaji.png',
    portionSize: '75GM',
    pricePerPortion: '₹90',
    basePrice: 90,
    serves: 5,
    quantity: '375GM',
    unit: 'GM'
  },
  {
    id: 336,
    title: 'Steamed Rice',
    category: 'main_course',
    description: 'Plain steamed rice, fluffy and light.',
    rating: 4.6,
    image: '/Images/JainMenuMAIN COURSE/10.Steamed Rice.png',
    portionSize: '75GM',
    pricePerPortion: '₹90',
    basePrice: 90,
    serves: 5,
    quantity: '375GM',
    unit: 'GM'
  },
  {
    id: 337,
    title: 'Jeera Rice',
    category: 'main_course',
    description: 'Cumin-tempered basmati rice, aromatic.',
    rating: 4.6,
    image: '/Images/JainMenuMAIN COURSE/11.Jeera Rice.png',
    portionSize: '75GM',
    pricePerPortion: '₹90',
    basePrice: 90,
    serves: 5,
    quantity: '375GM',
    unit: 'GM'
  },
  {
    id: 338,
    title: 'Veg Fried Rice',
    category: 'main_course',
    description: 'Stir-fried rice with mixed vegetables.',
    rating: 4.7,
    image: '/Images/JainMenuMAIN COURSE/12.Veg Fried Rice Peas Pulao.png',
    portionSize: '100GM',
    pricePerPortion: '₹100',
    basePrice: 100,
    serves: 5,
    quantity: '500',
    unit: 'portion'
  },
  {
    id: 339,
    title: 'Peas Pulao',
    category: 'main_course',
    description: 'Fragrant basmati rice with fresh green peas.',
    rating: 4.7,
    image: '/Images/JainMenuMAIN COURSE/12.Veg Fried Rice Peas Pulao.png',
    portionSize: '100GM',
    pricePerPortion: '₹100',
    basePrice: 100,
    serves: 5,
    quantity: '500',
    unit: 'portion'
  },
  {
    id: 343,
    title: 'Veg Biryani',
    category: 'main_course',
    description: 'Aromatic layered rice with vegetables and spices.',
    rating: 4.7,
    image: '/Images/JainNewImage/VEG BIRYANI.jpg',
    portionSize: '100GM',
    pricePerPortion: '₹90',
    basePrice: 90,
    serves: 5,
    quantity: '500',
    unit: 'portion'
  },
  {
    id: 344,
    title: 'Tandoori Roti',
    category: 'breads',
    description: 'Whole wheat roti baked in tandoor.',
    rating: 4.7,
    image: '/Images/Breads/1Tandoori Roti.jpg',
    portionSize: '1PC',
    pricePerPortion: '₹20',
    basePrice: 20,
    serves: 5,
    quantity: '5PCS',
    unit: 'PCS'
  },
  {
    id: 345,
    title: 'Tawa Roti',
    category: 'breads',
    description: 'Soft phulka-style roti from the tawa.',
    rating: 4.6,
    image: '/Images/Breads/6Tawa Roti.jpg',
    portionSize: '2PC',
    pricePerPortion: '₹18',
    basePrice: 18,
    serves: 5,
    quantity: '10PCS',
    unit: 'PCS'
  },
  {
    id: 346,
    title: 'Lachcha Paratha',
    category: 'breads',
    description: 'Layered, flaky whole-wheat paratha.',
    rating: 4.7,
    image: '/Images/Breads/3Lachcha Paratha.jpg',
    portionSize: '1PC',
    pricePerPortion: '₹40',
    basePrice: 40,
    serves: 5,
    quantity: '5PCS',
    unit: 'PCS'
  },
  {
    id: 347,
    title: 'Plain Naan',
    category: 'breads',
    description: 'Classic soft naan, tandoor baked.',
    rating: 4.7,
    image: '/Images/Breads/9Plain Naan.jpg',
    portionSize: '1PC',
    pricePerPortion: '₹30',
    basePrice: 30,
    serves: 5,
    quantity: '5PCS',
    unit: 'PCS'
  },
  {
    id: 348,
    title: 'Butter Naan',
    category: 'breads',
    description: 'Naan finished with butter, soft and rich.',
    rating: 4.8,
    image: '/Images/Breads/10Butter Naan.jpg',
    portionSize: '1PC',
    pricePerPortion: '₹30',
    basePrice: 30,
    serves: 5,
    quantity: '5PCS',
    unit: 'PCS'
  },
  {
    id: 349,
    title: 'Raita',
    category: 'breads',
    description: 'Curd-based side (no onion/garlic) with mild seasoning.',
    rating: 4.6,
    image: '/Images/Breads/7Raita.jpg',
    portionSize: '100GM',
    pricePerPortion: '₹60',
    basePrice: 60,
    serves: 5,
    quantity: '500GM',
    unit: 'GM'
  },
  {
    id: 350,
    title: 'Salad',
    category: 'breads',
    description: 'Fresh seasonal salad, Jain-friendly cut.',
    rating: 4.6,
    image: '/Images/Breads/8Salad.jpg',
    portionSize: '100GM',
    pricePerPortion: '₹50',
    basePrice: 50,
    serves: 5,
    quantity: '500GM',
    unit: 'GM'
  },

  // ===== DESSERTS =====
  {
    id: 351,
    title: 'Gulab Jamun',
    category: 'desserts',
    description: 'Soft khoya dumplings in rose-cardamom syrup.',
    rating: 4.9,
    image: '/Images/Desserts/1Gulab Jamun.jpg',
    portionSize: '2PC',
    pricePerPortion: '₹60',
    basePrice: 60,
    serves: 5,
    quantity: '10PCS',
    unit: 'PCS'
  },
  {
    id: 352,
    title: 'Rasgulla',
    category: 'desserts',
    description: 'Spongy chhena balls soaked in light syrup.',
    rating: 4.8,
    image: '/Images/Desserts/4Rasgulla.jpg',
    portionSize: '2PC',
    pricePerPortion: '₹60',
    basePrice: 60,
    serves: 5,
    quantity: '10PCS',
    unit: 'PCS'
  },
  {
    id: 353,
    title: 'Mango Phirni',
    category: 'desserts',
    description: 'Creamy rice pudding with mango purée.',
    rating: 4.8,
    image: '/Images/Desserts/3Mango Phirni.jpg',
    portionSize: '100GM',
    pricePerPortion: '₹60',
    basePrice: 60,
    serves: 5,
    quantity: '500GM',
    unit: 'GM'
  },
  {
    id: 354,
    title: 'Chocolate Brownie',
    category: 'desserts',
    description: 'Fudgy chocolate brownie slice.',
    rating: 4.7,
    image: '/Images/Desserts/7Chocolate Brownie.jpg',
    portionSize: '1.5PC',
    pricePerPortion: '₹60',
    basePrice: 60,
    serves: 5,
    quantity: '7.5PCS',
    unit: 'PCS'
  },
  {
    id: 355,
    title: 'Kheer',
    category: 'desserts',
    description: 'Traditional rice kheer with cardamom.',
    rating: 4.8,
    image: '/Images/Desserts/5Kheer.jpg',
    portionSize: '100GM',
    pricePerPortion: '₹60',
    basePrice: 60,
    serves: 5,
    quantity: '500GM',
    unit: 'GM'
  },

];
